import get from 'lodash/get.js'

import {
  onLabelPropertyValueChange,
  packagesSelector,
  updateLabelConfig,
  updateParcel,
} from '../../../../data/labelInfos/index.js'
import ConfigCheckbox from '../ConfigCheckbox.js'
import {UPS} from '../../../../common/constants/ShipperNames.js'
import {getState} from '../../../../store.js'
import {useLabelConfigContext} from '../../LabelConfigContext.js'
import {shipperOptionSelector} from '../../../../data/shipperOptions.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from '../useLabelProperty.js'

export const LABEL_PROPERTY_IS_MAIL_INNOVATIONS = 'is_mail_innovations'
const VALID_SHIPPER_TYPES = [UPS]

function updateIsMailInnovations(labelInfoID, shipperType, isMailInnovations) {
  const shipperOptions = shipperOptionSelector(getState(), {shipperType})

  const defaultBoxShape = isMailInnovations
    ? shipperOptions.box_shape_mail_innovations
    : shipperOptions.box_shape

  updateLabelConfig(labelInfoID, {
    is_mail_innovations: isMailInnovations,
  })

  const packages = packagesSelector(getState(), {labelInfoID})

  packages.forEach((_, index) =>
    updateParcel(labelInfoID, index, {
      [`${shipperType}__box_shape`]: get(defaultBoxShape, '0.value', null),
    }),
  )
}

export default function MailInnovations() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = MailInnovations.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigCheckbox
      label="Mail Innovations"
      onChange={(checked) => {
        updateIsMailInnovations(labelInfoID, shipperType, checked)

        onLabelPropertyValueChange(labelInfoID, labelProperty)

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
    />
  )
}

MailInnovations.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY_IS_MAIL_INNOVATIONS]
    },
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
